import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Emitter } from '../../../base/common/event.js';
import { Range } from '../../common/core/range.js';
import { findFirstInSorted } from '../../../base/common/arrays.js';
export var HiddenRangeModel = /*#__PURE__*/function () {
  function HiddenRangeModel(model) {
    var _this = this;

    _classCallCheck(this, HiddenRangeModel);

    this._updateEventEmitter = new Emitter();
    this._foldingModel = model;
    this._foldingModelListener = model.onDidChange(function (_) {
      return _this.updateHiddenRanges();
    });
    this._hiddenRanges = [];

    if (model.regions.length) {
      this.updateHiddenRanges();
    }
  }

  _createClass(HiddenRangeModel, [{
    key: "onDidChange",
    get: function get() {
      return this._updateEventEmitter.event;
    }
  }, {
    key: "hiddenRanges",
    get: function get() {
      return this._hiddenRanges;
    }
  }, {
    key: "updateHiddenRanges",
    value: function updateHiddenRanges() {
      var updateHiddenAreas = false;
      var newHiddenAreas = [];
      var i = 0; // index into hidden

      var k = 0;
      var lastCollapsedStart = Number.MAX_VALUE;
      var lastCollapsedEnd = -1;
      var ranges = this._foldingModel.regions;

      for (; i < ranges.length; i++) {
        if (!ranges.isCollapsed(i)) {
          continue;
        }

        var startLineNumber = ranges.getStartLineNumber(i) + 1; // the first line is not hidden

        var endLineNumber = ranges.getEndLineNumber(i);

        if (lastCollapsedStart <= startLineNumber && endLineNumber <= lastCollapsedEnd) {
          // ignore ranges contained in collapsed regions
          continue;
        }

        if (!updateHiddenAreas && k < this._hiddenRanges.length && this._hiddenRanges[k].startLineNumber === startLineNumber && this._hiddenRanges[k].endLineNumber === endLineNumber) {
          // reuse the old ranges
          newHiddenAreas.push(this._hiddenRanges[k]);
          k++;
        } else {
          updateHiddenAreas = true;
          newHiddenAreas.push(new Range(startLineNumber, 1, endLineNumber, 1));
        }

        lastCollapsedStart = startLineNumber;
        lastCollapsedEnd = endLineNumber;
      }

      if (updateHiddenAreas || k < this._hiddenRanges.length) {
        this.applyHiddenRanges(newHiddenAreas);
      }
    }
  }, {
    key: "applyMemento",
    value: function applyMemento(state) {
      if (!Array.isArray(state) || state.length === 0) {
        return false;
      }

      var hiddenRanges = [];

      var _iterator = _createForOfIteratorHelper(state),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var r = _step.value;

          if (!r.startLineNumber || !r.endLineNumber) {
            return false;
          }

          hiddenRanges.push(new Range(r.startLineNumber + 1, 1, r.endLineNumber, 1));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.applyHiddenRanges(hiddenRanges);
      return true;
    }
    /**
     * Collapse state memento, for persistence only, only used if folding model is not yet initialized
     */

  }, {
    key: "getMemento",
    value: function getMemento() {
      return this._hiddenRanges.map(function (r) {
        return {
          startLineNumber: r.startLineNumber - 1,
          endLineNumber: r.endLineNumber
        };
      });
    }
  }, {
    key: "applyHiddenRanges",
    value: function applyHiddenRanges(newHiddenAreas) {
      this._hiddenRanges = newHiddenAreas;

      this._updateEventEmitter.fire(newHiddenAreas);
    }
  }, {
    key: "hasRanges",
    value: function hasRanges() {
      return this._hiddenRanges.length > 0;
    }
  }, {
    key: "isHidden",
    value: function isHidden(line) {
      return findRange(this._hiddenRanges, line) !== null;
    }
  }, {
    key: "adjustSelections",
    value: function adjustSelections(selections) {
      var _this2 = this;

      var hasChanges = false;
      var editorModel = this._foldingModel.textModel;
      var lastRange = null;

      var adjustLine = function adjustLine(line) {
        if (!lastRange || !isInside(line, lastRange)) {
          lastRange = findRange(_this2._hiddenRanges, line);
        }

        if (lastRange) {
          return lastRange.startLineNumber - 1;
        }

        return null;
      };

      for (var i = 0, len = selections.length; i < len; i++) {
        var selection = selections[i];
        var adjustedStartLine = adjustLine(selection.startLineNumber);

        if (adjustedStartLine) {
          selection = selection.setStartPosition(adjustedStartLine, editorModel.getLineMaxColumn(adjustedStartLine));
          hasChanges = true;
        }

        var adjustedEndLine = adjustLine(selection.endLineNumber);

        if (adjustedEndLine) {
          selection = selection.setEndPosition(adjustedEndLine, editorModel.getLineMaxColumn(adjustedEndLine));
          hasChanges = true;
        }

        selections[i] = selection;
      }

      return hasChanges;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (this.hiddenRanges.length > 0) {
        this._hiddenRanges = [];

        this._updateEventEmitter.fire(this._hiddenRanges);
      }

      if (this._foldingModelListener) {
        this._foldingModelListener.dispose();

        this._foldingModelListener = null;
      }
    }
  }]);

  return HiddenRangeModel;
}();

function isInside(line, range) {
  return line >= range.startLineNumber && line <= range.endLineNumber;
}

function findRange(ranges, line) {
  var i = findFirstInSorted(ranges, function (r) {
    return line < r.startLineNumber;
  }) - 1;

  if (i >= 0 && ranges[i].endLineNumber >= line) {
    return ranges[i];
  }

  return null;
}